import { authService } from '@oneblink/apps-react'
import { PropsWithChildren, useEffect, useState } from 'react'

function AuthCheck({ children }: PropsWithChildren<Record<string, unknown>>) {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    async function checkToken() {
      setIsLoading(true)
      try {
        // try to access id token, if fails == token expired
        await authService.getIdToken()
      } catch (e) {
        console.log('Refresh token expired! Logging out...')
        await authService.logout()
      }
      setIsLoading(false)
    }

    checkToken()
  }, [])

  if (isLoading) return null

  return <>{children}</>
}

export default AuthCheck
